'use strict';

var wishlist = require('core/wishlist/wishlist');

wishlist.baseFiles.wishlistToggleProduct = require('client_core/wishlist/components/toggleProduct');

module.exports = wishlist;